<div #textareaWrap class="textarea-wrap" (click)="setFocus()">
  <textarea
    #textarea
    [rtTextareaAutosize]="autosize"
    [rtAutosizeMinRows]="autosizeMinRows"
    [rtAutosizeMaxRows]="autosizeMaxRows"
    [disabled]="disabled"
    [readOnly]="readOnly"
    [rows]="rows"
    [placeholder]="placeholder || ''"
    [attr.maxlength]="maxLength"
    [attr.tabindex]="tabIndex"
    [style.width]="width"
    [style.height]="height"
    [style.overflow]="overflowHidden ? 'hidden' : null"
    (input)="handleChange($event.target.value)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
  >
  </textarea>
  <ng-container *ngIf="charactersLimit" [ngTemplateOutlet]="charactersCounter"></ng-container>
</div>

<ng-template #charactersCounter>
  <div class="characters-counter">{{ controlValue?.length || 0 }} / {{ charactersLimit }}</div>
</ng-template>

<rt-icon *ngIf="icon" [name]="icon" (click)="iconClick.emit()" class="onInput"></rt-icon>
